const constructionDetailsData = {
    materials: {
        title: 'Premium Building Materials',
        description: 'We use only the highest quality materials in our construction projects, ensuring durability, safety, and aesthetic appeal.',
        items: [
            'Structural concrete with minimum strength class C25/30',
            'Premium ceramic or porcelain tiles from top European manufacturers',
            'Triple-glazed windows with thermal break aluminum frames',
            'Top-grade engineered hardwood or luxury vinyl flooring',
            'High-quality gypsum board systems for interior walls',
            'Premium weather-resistant exterior finishes'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-1.webp',
    },
    insulation: {
        title: 'Superior Insulation Solutions',
        description: 'Our buildings feature comprehensive insulation systems that ensure energy efficiency, thermal comfort, and noise reduction.',
        items: [
            'External wall insulation system with minimum 15cm thermal insulation',
            'Acoustic insulation between apartments and floors',
            'Roof insulation with minimum 25cm thermal insulation layer',
            'Floor insulation with 10cm polystyrene panels',
            'Triple-glazed windows with thermal break and low-E glass',
            'Thermal bridge elimination techniques'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-2.jpg',
    },
    technology: {
        title: 'Integrated Smart Technology',
        description: 'Our buildings are equipped with modern technology solutions that enhance comfort, security, and energy efficiency.',
        items: [
            'Smart home systems pre-installation',
            'Building management system for common areas',
            'High-speed fiber optic internet connectivity',
            'Video intercom system with smartphone integration',
            'Smart metering for utilities',
            'Electric vehicle charging stations'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-3.avif',
    },
    security: {
        title: 'Advanced Security Features',
        description: 'Security is paramount in our developments, with multi-layered systems to ensure the safety of residents and their property.',
        items: [
            'Access control systems in all common areas',
            'CCTV surveillance of entrances and common spaces',
            'Advanced fire detection and sprinkler systems',
            'Security-rated entrance doors to apartments',
            'Underground parking with secure access',
            'Security concierge service in larger developments'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-4.jpg',
    },
    sustainability: {
        title: 'Sustainable Construction Practices',
        description: 'Environmental responsibility is at the core of our construction philosophy, with multiple features aimed at reducing environmental impact.',
        items: [
            'Energy-efficient heating and cooling systems',
            'Solar panel pre-installation on roofs',
            'Rainwater collection systems',
            'Low VOC paints and materials',
            'Green spaces with native plant species',
            'Waste sorting and recycling facilities'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-5.jpg',
    },
    quality: {
        title: 'Rigorous Quality Standards',
        description: 'Quality control is embedded throughout our construction process, with regular inspections and testing to ensure excellence.',
        items: [
            'Third-party quality inspections at key construction phases',
            'Structural integrity testing beyond regulatory requirements',
            'Air tightness testing for all units',
            'Acoustic performance testing',
            'Extended warranties on key building components',
            'Post-completion quality assessment'
        ],
        image: 'https://arcdom.b-cdn.net/construction/construction-6.avif',
    },
};

export default constructionDetailsData;
